export const BRAND_NAME = "Seeds of Innocens";
export const CRM_NAME = `${BRAND_NAME} CRM`;
export const BRAND_SLUG = "seedsofinnocens";
export const BRAND_DOMAIN = "seedsofinnocens.com";
export const BRAND_LOGO = "/brand/soi-logo.svg";
